import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { useSession, useAnalytics } from 'hooks';
import { MIXPANEL_EVENTS } from 'constants/constants';
import { getDashboardPath } from 'hooks/useSession';

import Login from 'components/user/Login/Login';

const LoginPage = () => {
  const { authenticated, user } = useSession();
  const { trackEvent } = useAnalytics();

  if (authenticated) {
    return <Redirect to={getDashboardPath(user.type)} />;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    trackEvent(MIXPANEL_EVENTS.login);
  }, [trackEvent]);

  return <Login />;
};

export default LoginPage;
